document.addEventListener('DOMContentLoaded', () => {
    const footer = document.querySelector('.Footer');
    if (!footer) return;

    const bgs = JSON.parse(footer.dataset.bgs || '[]');
    if (!bgs.length) return;

    let index = 0;

    // Tworzymy 2 divy w tle
    const bg1 = document.createElement('div');
    const bg2 = document.createElement('div');
    [bg1, bg2].forEach(bg => {
        bg.style.cssText = `
            position: absolute;
            top:0; left:0; right:0; bottom:0;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            z-index: 0;
            transition: opacity 1s ease-in-out;
        `;
        footer.appendChild(bg);
    });

    bg1.style.opacity = 1;
    bg1.style.backgroundImage = `url(${bgs[0]})`;
    bg2.style.opacity = 0;

    setInterval(() => {
        const nextIndex = (index + 1) % bgs.length;

        // Wybierz który bg jest widoczny
        const current = index % 2 === 0 ? bg1 : bg2;
        const next = index % 2 === 0 ? bg2 : bg1;

        next.style.backgroundImage = `url(${bgs[nextIndex]})`;
        next.style.opacity = 1;
        current.style.opacity = 0;

        index = nextIndex;
    }, 5000);
});
